/** The customer's order history, order details, receipts and invoices. */
export default {
  planLabel: "{{plan}} plan",
  orderNumber: "Order #{{id}}",
  creditsCount_one: "{{count}} point",
  creditsCount_other: "{{count}} points",
  status: {
    paid: "Paid",
    pending_payment: "Pending",
    cancelled: "Cancelled",
    refunded: "Refunded",
  },
  history: {
    title: "Order history",
    subtitle: "Your point purchases, with receipts and invoices.",
    count_one: "{{count}} order",
    count_other: "{{count}} orders",
    empty: "No orders yet",
    emptyBody: "Points you buy will show up here.",
    loadMore: "Show more",
    loadFailed: "Could not load your orders.",
    viewDetails: "View order details",
  },
  documents: {
    title: "Receipt & invoice",
    subtitle: "Document no. {{number}}",
    subtitlePending: "Your documents are generated when you open them.",
    receipt: "Payment receipt",
    invoice: "Invoice",
    view: "View",
    download_receipt: "Download receipt",
    download_invoice: "Download invoice",
    failed: "Could not load the document. Please try again.",
  },
  detail: {
    promo: "Promo code {{code}}",
    backToProfile: "Back to profile",
    notFound: "We couldn't find that order in your account.",
    total: "Total",
    summary: "Order summary",
    benefitsLevel: "{{level}} benefits",
    transaction: "Transaction details",
    placed: "Placed",
    paid: "Paid",
    method: "Payment method",
    cardVia: "Card via {{bank}}",
    notChosen: "Not chosen",
    reference: "Bank reference",
    receiptNumber: "Receipt no.",
    currency: "Currency",
    billedTo: "Billed to",
    noBilling: "No billing details were given.",
    statusNote: {
      pending_payment:
        "This payment has not been confirmed yet. If you completed it, it will update shortly; otherwise no money was taken.",
      cancelled: "This payment was cancelled or declined. No money was taken and no points were added.",
      refunded: "This payment was refunded to your card. Your points remain on your account.",
    },
  },
};
